const COLOR_OPTION_NAMES = new Set(['colour', 'color', 'farbe']);

const getColorOptionFieldset = (productRoot) => {
  const fieldsets = productRoot.querySelectorAll('fieldset.single-option-radio');

  for (const fieldset of fieldsets) {
    const optionName = fieldset
      .querySelector('.options-color-wrapper')
      ?.getAttribute('data-option-name');

    if (optionName && COLOR_OPTION_NAMES.has(optionName.toLowerCase())) {
      return fieldset;
    }

    if (fieldset.querySelector('.options-color.option-item')) {
      return fieldset;
    }
  }

  return null;
};

const getSelectedColor = () => {
  const productRoot = document.querySelector('.product_template_new');
  if (!productRoot) return '';

  const colorFieldset = getColorOptionFieldset(productRoot);

  if (colorFieldset) {
    const checkedInput = colorFieldset.querySelector(
      'input.single-option-selector__radio:checked'
    );
    if (checkedInput?.value) return checkedInput.value;

    const activeWrapper = colorFieldset.querySelector('.options-color-wrapper.active');
    const optionItem = activeWrapper?.querySelector('.option-item[data-value]');
    if (optionItem?.getAttribute('data-value')) {
      return optionItem.getAttribute('data-value');
    }
  }

  const activeColorItem = productRoot.querySelector(
    '.options-color-wrapper.active .options-color.option-item[data-value]'
  );
  return activeColorItem?.getAttribute('data-value') || '';
};

const parseVariantMatch = (str) => {
  const trimmed = (str || '').trim();
  if (!trimmed) return null;
  return trimmed.split(',').map((item) => item.trim()).filter(Boolean);
};

const updateBenefitVisibility = () => {
  const productRoot = document.querySelector('.product_template_new');
  if (!productRoot) return;

  const selectedColor = getSelectedColor();
  const wrappers = productRoot.querySelectorAll('[data-variant-match]');

  wrappers.forEach((wrapper) => {
    const allowedColors = parseVariantMatch(wrapper.getAttribute('data-variant-match'));

    if (allowedColors === null) {
      wrapper.classList.remove('is-variant-hidden');
      return;
    }

    const shouldHide = !allowedColors.includes(selectedColor);
    wrapper.classList.toggle('is-variant-hidden', shouldHide);
  });
};

const scheduleBenefitVisibilityUpdate = () => {
  window.requestAnimationFrame(() => {
    window.requestAnimationFrame(() => {
      updateBenefitVisibility();
    });
  });
};

const initBenefitVariantVisibility = () => {
  const productRoot = document.querySelector('.product_template_new');
  if (!productRoot) return;

  updateBenefitVisibility();

  productRoot.addEventListener('click', (event) => {
    const target = event.target;
    if (!(target instanceof Element)) return;
    if (!target.closest('.options-color-wrapper, .o-swatch')) return;

    scheduleBenefitVisibilityUpdate();
  });

  productRoot.addEventListener('change', (event) => {
    const target = event.target;
    if (!(target instanceof Element)) return;
    if (!target.matches('input.single-option-selector__radio')) return;

    scheduleBenefitVisibilityUpdate();
  });

  if (window.jQuery) {
    window.jQuery(document).on('variantChange.productSection', scheduleBenefitVisibilityUpdate);
  }
};

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initBenefitVariantVisibility);
} else {
  initBenefitVariantVisibility();
}
